import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { getFontSizeForScreen } from '../../utils/fontUtils';
import { localAnalytics } from '../../utils/analytics';

interface CloseButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClose: () => void;
  analyticsEvent?: string;
  themeMode?: 'light' | 'dark';
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  onClose,
  analyticsEvent,
  style,
  themeMode = 'light',
  ...props
}) => {
  const { theme, themeMode: themeModeContext } = useTheme();

  const themeModeFinal = themeMode || themeModeContext;

  const handleClick = () => {
    if (analyticsEvent) {
      localAnalytics().logEvent(analyticsEvent);
    }
    onClose();
  };

  const imageSize = getFontSizeForScreen('h2');
  const imageSrc =
    themeModeFinal === 'light'
      ? '/img/books/close_light.png'
      : '/img/books/close_dark.png';

  const buttonStyles: React.CSSProperties = {
    backgroundColor: 'transparent',
    color: themeModeFinal === 'light' ? theme.colors.white : theme.colors.black,
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    ...style,
  };

  return (
    <button
      style={buttonStyles}
      onClick={handleClick}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = theme.colors.overlay;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
      {...props}
    >
      <img
        src={imageSrc}
        alt="Close"
        style={{
          width: imageSize,
          height: imageSize,
          display: 'block',
        }}
      />
    </button>
  );
};
